
import FAQAccordion from "@/components/faqs/FAQAccordion";
import { FAQ } from "./types";

interface FAQCategoryProps {
  faqs: FAQ[];
  categoryId: string;
}

const FAQCategory = ({ faqs, categoryId }: FAQCategoryProps) => {
  return <FAQAccordion faqs={faqs} categoryId={categoryId} />;
};

export default FAQCategory;
